/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ComplianceAssessmentControlDetail {
    getFixupPrototypeFunction() { return ComplianceAssessmentControlDetail.fixupPrototype; }

    static newInstance(model: Partial<ComplianceAssessmentControlDetail>): ComplianceAssessmentControlDetail {
        let obj = Object.assign(new ComplianceAssessmentControlDetail(), model);
        ComplianceAssessmentControlDetail.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ComplianceAssessmentControlDetail>): ComplianceAssessmentControlDetail {
        if (!model) return null;
        return ComplianceAssessmentControlDetail.newInstance(<ComplianceAssessmentControlDetail> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ComplianceAssessmentControlDetail) {
        if (!obj) return;

        models.ComplianceAssessmentControlDetail.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ComplianceAssessmentControlDetail): boolean {
        Object.setPrototypeOf(obj, ComplianceAssessmentControlDetail.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.assessment_control_evidence) {
            for (let val of this.assessment_control_evidence) {
                models.ComplianceAssessmentControlEvidence.fixupPrototype(val);
            }
        }
        if (this.policy_output) {
            for (let val of this.policy_output) {
                models.PolicyOutput.fixupPrototype(val);
            }
        }
    }

    /**
     * Unique ID for the assessment control ID
     */
    assessment_control_id: string;

    /**
     * Tenant ID
     */
    tenant_id: string;

    /**
     * Status of compliance control
     */
    assessment_control_status: models.ComplianceControlStatus;

    assessment_control_evidence: Array<models.ComplianceAssessmentControlEvidence>;

    /**
     * Unique URI for the compliance control
     */
    compliance_control_uri: string;

    /**
     * Unique ID for the assessment history
     */
    assessment_history_id: string;

    /**
     * List of latest policy executions associated with the compliance assessment
     */
    policy_output: Array<models.PolicyOutput>;

}
